import { httpGet, httpPost } from "../connection";

export async function getRecentEvidence(params = {}) {
  return await httpGet(`/evidence/recent`, params);
}

export async function addRecentEvidence(values = {}) {
  return await httpPost(`/evidence/recent`, values);
}
